import React from "react";
import { SiTicktick } from "react-icons/si";
import cover from "../../assets/dhruvtara/cover.png";
import img1 from "../../assets/dhruvtara/1.png";
import img2 from "../../assets/dhruvtara/2.png";
import img3 from "../../assets/dhruvtara/3.png";
import img4 from "../../assets/dhruvtara/4.png";
import img5 from "../../assets/dhruvtara/5.png";
import img6 from "../../assets/dhruvtara/6.png";

const cards = [
  {
    title: "Akshar Volunteership",
    point1: "Free education for underprivileged kids",
    point2: "Volunteer-driven mentoring",
    point3: "Focus on core subjects",
    image: img1,
  },
  {
    title: "Career Bootcamps",
    point1: "Career and skill sessions",
    point2: "Internship and college guidance",
    point3: "Mentor and industry connects",
    image: img2,
  },
  {
    title: "E-Vidyaloka Collab",
    point1: "Simple modules for rural kids",
    point2: "Supports digital learning",
    point3: "Improves curriculum delivery",
    image: img3,
  },
  {
    title: "Library on Wheels",
    point1: "Books to remote communities",
    point2: "Promotes reading habits",
    point3: "Encourages book donations",
    image: img4,
  },
  {
    title: "VED Courses",
    point1: "Teaches moral values",
    point2: "Character-building activities",
    point3: "Focus on holistic growth",
    image: img5,
  },
  {
    title: "Stationery Drive",
    point1: "Supplies for needy students",
    point2: "Removes learning barriers",
    point3: "Supports equal access",
    image: img6,
  },
];

export default function Cards() {
  return (
    <>
      <div className="bg-[#51C4E1]">
        <img src={cover} alt="" className="w-80 mx-auto block mb-[-60px]" />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 text-left p-6 sm:pb-8 lg:pb-12 gap-6">
          {cards.map((card, index) => (
            <div
              key={index}
              className="shadow-md p-6 rounded-lg bg-white text-[#257377] font-semibold text-md relative border border-b-8 border-b-[#003253] flex flex-col"
            >
              <img
                src={card.image}
                alt={card.title}
                className="w-16 h-16  hidden md:block  absolute top-4 right-4 max-w-full"
              />
              <h2 className="text-lg font-bold mb-2 text-gray-600">
                {card.title}
              </h2>
              <p className="text-gray-600 flex items-center mb-2">
                <SiTicktick className="mr-2 text-green-600" />
                {card.point1}
              </p>
              <p className="text-gray-600 flex items-center mb-2">
                <SiTicktick className="mr-2 text-green-600" />
                {card.point2}
              </p>
              <p className="text-gray-600 flex items-center">
                <SiTicktick className="mr-2 text-green-600" />
                {card.point3}
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
